import { head } from "lodash-es";

import {
	MobileRegistrationPromotion,
	MobileRegistrationPromotionResponseItem,
} from "./mobile-registration-promotion.model";

export function processMobileRegistrationPromotion(
	rawItem: MobileRegistrationPromotionResponseItem
): MobileRegistrationPromotion {
	const content = rawItem.content;

	return {
		key: rawItem.documentKey,
		banner: head(content.banner),
		title: head(content.title),
		subtitle: head(content.subtitle),
	};
}
